import ApiTimeEntry from "@/api/time_entry/timeEntry"
import errorDialog from "@/views/ErrorDialog/errorDialog";
import { actions as dialogModule } from "@/store/modules/dialog";
import {$t} from "@/i18n";

const completeTaskForEveryone = async (virtualId, billable) => {
    try {
        await ApiTimeEntry.completeTask(virtualId, 'all', billable)
    } catch (e) {
        errorDialog.showError(e)
    }
}

const completeTaskForMe = async (virtualId, billable) => {
    try {
        await ApiTimeEntry.completeTask(virtualId, 'me', billable)
    } catch (e) {
        errorDialog.showError(e)
    }
}

export const completeTask = async (virtualId, showError = true, billable = 1) => {
    try {
        await ApiTimeEntry.completeTask(virtualId, '', billable)
    } catch (e) {
        if (e.response.data.errors.length === 1 && e.response.data.errors[0].error_message === 'show_complete_type_all_or_me') {
            dialogModule.setConfirmOptions({
                title: $t("Do you wish to mark the task done for everyone?"),
                confirm_text: $t("No, remove me"),
                action_tooltip: $t("Task won’t be marked done, but user is removed from the assignees and added to the followers of the task"),
                confirm_text2: $t("Yes"),
                cancel_text: $t("Cancel"),
                action: () => completeTaskForMe(virtualId, billable),
                action2: () => completeTaskForEveryone(virtualId, billable)
            });
            dialogModule.openConfirmDialog()
        } else if (e.response.data.errors.length === 1 && e.response.data.errors[0].error_message === 'show_complete_type_all') {
            dialogModule.setConfirmOptions({
                title: $t("Do you wish to mark the task done for everyone?"),
                confirm_text: $t("Yes"),
                cancel_text: $t("Cancel"),
                action: () => completeTaskForEveryone(virtualId, billable)
            });
            dialogModule.openConfirmDialog()
        } else {
            if (showError) {
                errorDialog.showError(e)
            } else {
                throw e
            }
        }
    }
}

export default {
    completeTask
}